import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form } from 'semantic-ui-react'
import { formatNumber } from '~/utils/helpers'
import { PhaseWrapper } from './style'

const AssignPhases: React.FC = () => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext()

  const watchSelectedFeedGroups = useWatch({ control, name: 'selectedFeedGroups' })
  const watchFeedGroups = useWatch({ control, name: 'feedGroups' })

  useEffect(() => {
    const selectedFeedGroups = []
    watchFeedGroups.map((feedGroup, index) => {
      if (feedGroup?.feedingPhases?.length > 0) {
        selectedFeedGroups.push(index)
      }
    })
    setValue('selectedFeedGroups', selectedFeedGroups)
  }, [])

  function renderAssignPhasesContent() {
    return <div>
      <Form>
        <Form.Select
          multiple
          selectOnBlur={false}
          selection
          placeholder={t('Select feed groups')}
          value={watchSelectedFeedGroups}
          onChange={(_, data) => {
            setValue('selectedFeedGroups', data.value as (string | number | boolean)[])
          }}
          options={watchFeedGroups?.map((feedGroup, index) => {
            const cowsNrInRelToDaysGroup = feedGroup.cattleNumber
            return { value: index, text: `${feedGroup.name} (${formatNumber(cowsNrInRelToDaysGroup, 0)} Tiere)` }
          })}
        />
      </Form>
    </div>
  }

  return <PhaseWrapper>
    <div style={{ marginBottom: 3 }}>{'Leistungsgruppe auswählen'}</div>
    {renderAssignPhasesContent()}
  </PhaseWrapper>
}
export default AssignPhases